module.exports = __webpack_public_path__ + "static/media/secretariat.a21abf04.pdf";